import React from 'react';
import styled from 'styled-components';
import { Button } from '@plecto/ui';
import { Loader } from '../common/loaders/Loader';
import { useTranslation } from 'react-i18next';

const SlideInFooter = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 10px 20px;
	gap: 10px;
	border-top: 1px solid #E5E7EB;
	background-color: #FFFFFF;
	${Button.cssSelector} {
		flex: 1 auto;
	}
`;

export default function Footer({ onSave, onClose, isSaving, cancelText, saveText }) {
	const { t } = useTranslation();
	return <SlideInFooter className={'slide-in-footer'}>
		<Button onClick={onClose}>{cancelText || t('Cancel')}</Button>
		<Button variant={'primary'} onClick={onSave}>{isSaving ? <Loader /> : (saveText || t('Save'))}</Button>
	</SlideInFooter>;
}
